import React, { useState } from 'react';
import InputCustom from '../../../../Components/InputCustom';

export default function PromotedList({
	addPromotedProductManualy
}) {

	const [valueToModify, setValueToModify] = useState('');

	const handleChange = (event) => {
		let textAreaValue = { ...valueToModify };
		textAreaValue = event.target.value;
		setValueToModify(textAreaValue);
		addPromotedProductManualy(textAreaValue);
	};

	return (
		<InputCustom
			type="textarea"
			value={valueToModify && valueToModify}
			placeholder="Type product ids here (line break or semi-colon separated)"
			onChange={handleChange}
			rows={16}
			fullWidth={true}
		/>
	);
}
